<template>
  <v-card style="min-height: 85vh">
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"> Famiglie Articoli </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Bottone di aggiunta famiglia -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="aggiungiFamigliaArticolo"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary"> mdi-plus </v-icon>
          </v-btn>
        </template>
        <span>Nuovo Record</span>
      </v-tooltip>

      <!-- Bottone di salvataggio -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="clickSalvataggioGenerale"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Salva</span>
      </v-tooltip>

      <!-- Bottone di gestione delle fasi di montaggio -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="clickGestioneMontaggioFamiglia"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary"> mdi-cog </v-icon>
          </v-btn>
        </template>
        <span>Gestione Montaggio Famiglia</span>
      </v-tooltip>

      <!-- Bottone della gestione delle colonne -->
      <Modules
        :activator_item="'button'"
        :bg_color="'indigo'"
        :button_icon_color="'primary'"
        :colonne_aggiuntive="[
          {
            text: 'Ordine',
            value: 'ordine',
            align: null,
            sortable: null,
            visible: 0,
          },
        ]"
        :icon="'mdi-table-column-width'"
        v-on:dialogModules="getTabelle"
        tipo="PARTE_BARCA"
        nome="Colonne Diario"
        setaction="settabelle"
        getaction="gettabelle"
        controller="Magazzino"
        filter="validita = 1"
        :dati="[{ des: '' }, {cod: ''}, { ordine: '' }]"
      />

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickIndietro" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-keyboard-backspace </v-icon>
          </v-btn>
        </template>
        <span>Indietro</span>
      </v-tooltip>
    </v-toolbar>

    <v-card-text>
      <!-- Spazio per i filtri di ricerca -->
      <v-container>
        <v-row align="center" justify="center">
          <v-col class="py-0" cols="12">
            <div>
              <div class="mx-5" style="display: inline-block">
                <v-autocomplete
                  :items="items_famiglie_tabella"
                  item-text="des"
                  item-value="id_tabella"
                  label="Famiglia"
                  v-model="search_famiglia"
                >
                  <template #label>
                    <span class="">Famiglia</span>
                    <a @click.stop style="pointer-events: all">
                      <Modules
                        v-on:dialogModules="aggiornaFamiglia"
                        tipo="Famiglia"
                        nome="Famiglia"
                        setaction="settabelle"
                        getaction="gettabelle"
                        controller="Magazzino"
                        filter="validita = 1"
                        :dati="[{ des: '' }]"
                      />
                    </a>
                  </template>
                  <template v-slot:append>
                    <v-btn
                      @click="search_famiglia = null"
                      icon
                      small
                      v-show="search_famiglia != null"
                    >
                      <v-icon color="error">mdi-close</v-icon>
                    </v-btn>
                  </template>
                </v-autocomplete>
              </div>
              <div class="mx-5" style="display: inline-block">
                <v-autocomplete
                  :items="items_famiglie.filter((e) => e.validita === 1)"
                  :item-text="(e) => e.marchio"
                  :item-value="(e) => e.marchio"
                  label="Marchio"
                  v-model="search_marchio"
                >
                  <template v-slot:append>
                    <v-btn
                      @click="search_marchio = null"
                      icon
                      small
                      v-show="search_marchio != null"
                    >
                      <v-icon color="error">mdi-close</v-icon>
                    </v-btn>
                  </template>
                </v-autocomplete>
              </div>
              <div class="mx-5" style="display: inline-block">
                <v-autocomplete
                  :items="items_modelli"
                  :item-text="(e) => e"
                  :item-value="(e) => e"
                  label="Modello"
                  v-model="search_modello"
                >
                  <template v-slot:append>
                    <v-btn
                      @click="search_modello = null"
                      icon
                      small
                      v-show="search_modello != null"
                    >
                      <v-icon color="error">mdi-close</v-icon>
                    </v-btn>
                  </template>
                </v-autocomplete>
              </div>
              <div class="mx-5" style="display: inline-block">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="ricerca" small v-bind="attrs" v-on="on">
                      <v-icon color="primary"> mdi-magnify </v-icon>
                    </v-btn>
                  </template>
                  <span>Cerca</span>
                </v-tooltip>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <!-- Card per avvisare che non ci sono risultati ricerca -->
      <div class="mt-5" v-if="items_famiglie_visualizzate.length === 0">
        <div style="display: inline-block">
          <v-card outlined style="max-width: 500px">
            <v-card-text>
              Nessuna famiglia corrisponde ai criteri di ricerca indicati.
            </v-card-text>
          </v-card>
        </div>
      </div>

      <!-- Tabella dei risultati -->
      <v-data-table
        :headers="headers_famiglie"
        :height="'80vh'"
        :items="items_famiglie_visualizzate.filter((e) => e.validita === 1)"
        v-if="items_famiglie_visualizzate.length > 0"
      >
        <!-- Bottone di modifica -->
        <template v-slot:[`item.modifica`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="clickModifica(item)"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary"> mdi-pencil </v-icon>
              </v-btn>
            </template>
            <span>Modifica</span>
          </v-tooltip>
        </template>

        <!-- Colonna dei modelli -->
        <template v-slot:[`item.modelli`]="{ item }">
          {{ formattaModelli(item) }}
        </template>

        <!-- Bottone di dettaglio articoli -->
        <template v-slot:[`item.immagine`]="{ item }">
          <MiniaturaComprimibile
            :id_referente="item.id_famiglia_articolo"
            @immagine_full="handleImmagineFull(item, $event)"
            :immagine_full="item.immagine_full"
            :immagine_miniatura="item.immagine"
            @scelta_immagine="handleSceltaImmagine(item, $event)"
            :tipo_allegato="'FAMIGLIA_ARTICOLO'"
          />
        </template>

        <!-- Bottone di dettaglio articoli -->
        <template v-slot:[`item.articoli`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="clickArticoli(item)"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary"> mdi-arrow-top-right-thin </v-icon>
              </v-btn>
            </template>
            <span>Vai agli Articoli</span>
          </v-tooltip>
        </template>

        <!-- Bottone di eliminazione righe -->
        <template v-slot:[`item.elimina`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="clickEliminaRiga(item)"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Cancella</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card-text>

    <!-- Dialog di modifica delle righe -->
    <v-dialog v-model="dialog_modifica" width="600px">
      <v-card style="max-width: 600px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"
            >Modifica Famiglia: {{ riga_sel.des }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaModifiche" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva Modifiche</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiDialogModifica"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="overflow-y: auto">
          <v-container>
            <v-row align="center" justify="center">
              <v-col align="center" cols="12">
                <v-text-field
                  label="Marchio"
                  style="max-width: 250px"
                  v-model="riga_sel.marchio"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col cols="12">
                <div class="my-3" style="text-align: left">
                  <span
                    class="mr-5"
                    style="font-size: 18px; color: rgb(0, 0, 0)"
                  >
                    Modelli per Questo Marchio
                  </span>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="aggiungiModello"
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="primary"> mdi-plus </v-icon>
                      </v-btn>
                    </template>
                    <span>Aggiungi Modello</span>
                  </v-tooltip>
                </div>
                <div style="text-align: left">
                  <v-chip
                    class="elevation-2 mr-3"
                    color="primary"
                    v-for="(item, i) in riga_sel.modelli"
                    :key="i"
                  >
                    <span>{{ item }}</span>
                    <v-btn class="ml-2" @click="modificaModello(i)" icon small>
                      <v-icon color="white">mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn @click="clickEliminaModello(i)" icon small>
                      <v-icon color="white">mdi-delete</v-icon>
                    </v-btn>
                  </v-chip>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di modifica dei modelli -->
    <v-dialog v-model="dialog_modifica_modello" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaModello" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiDialogModificaModello"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="overflow-y: auto">
          <v-container>
            <v-row align="center" justify="center">
              <v-col cols="12">
                <v-text-field v-model="modello_sel"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma prima del salvataggio -->
    <v-dialog v-model="dialog_conferma_salvataggio" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Salvataggio </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler salvare le configurazioni attuali?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn
                  class="mr-5"
                  @click="dialog_conferma_salvataggio = false"
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="salvataggioGenerale" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma eliminazione dei modelli -->
    <v-dialog v-model="conferma_elimina_modello" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Eliminazione </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler eliminare il modello selezionato?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn class="mr-5" @click="annullaEliminaModello" small>
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="eliminaModello" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma eliminazione dlle righe -->
    <v-dialog v-model="conferma_elimina_riga" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Eliminazione </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler eliminare il record selezionato?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn class="mr-5" @click="annullaEliminaRiga" small>
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="eliminaRiga" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di configurazione della famiglia per una nuova riga -->
    <v-dialog v-model="dialog_aggiungi_famiglia" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="salvaAggiungiFamiglia"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiDialogAggiungiFamiglia"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Indicare la famiglia a cui associare il nuovo record:
          </span>
          <v-container>
            <v-row align="center" justify="center">
              <v-col
                align="center"
                class="my-0 py-0"
                justify="center"
                cols="12"
              >
                <v-autocomplete
                  :items="items_famiglie_tabella"
                  item-text="des"
                  item-value="id_tabella"
                  label="Famiglia"
                  style="max-width: 250px"
                  v-model="riga_sel.id_tabella"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog gestione montaggio famiglia -->
    <v-dialog v-model="dialog_gestisci_montaggio_famiglia">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Gestione Montaggio Famiglia
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template bottom v-slot:activator="{ on, attrs }">
              <v-btn
                @click="salvaGestisciMontaggioFamiglia"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template bottom v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_gestisci_montaggio_famiglia = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-data-table
            :headers="headers_diario"
            :items="items_famiglie_diario"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td style="text-align: left">
                  {{ item.des_famiglia }}
                </td>
                <td
                  style="text-align: left"
                  v-for="header in headers_diario.filter(
                    (h) => h.value != 'des_famiglia'
                  )"
                  :key="header.value"
                >
                  <v-icon
                    @click="
                      switchOnOff(
                        item.abilitazioni.filter(
                          (a) => a.des_caratteristica === header.text
                        )[0]
                      )
                    "
                    :color="
                      item.abilitazioni.filter(
                        (a) => a.des_caratteristica === header.text
                      )[0].abilitato == 1
                        ? 'success'
                        : 'error'
                    "
                  >
                    {{
                      item.abilitazioni.filter(
                        (a) => a.des_caratteristica === header.text
                      )[0].abilitato == 1
                        ? "mdi-check"
                        : "mdi-close"
                    }}
                  </v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import _ from "lodash";
import axios from "axios";
import MiniaturaComprimibile from "@/components/TOOLS/MiniaturaComprimibile.vue";
// import Modules from "@/components/TOOLS/Modules.vue";
import moment from "moment/moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Riga {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] =
          arg[c.nome] != undefined
            ? c.complex === false
              ? arg[c.nome]
              : _.cloneDeep(arg[c.nome])
            : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "be_call_needed", default_val: false, complex: false },
      { nome: "des", default_val: "", complex: false },
      { nome: "id_famiglia_articolo", default_val: -1, complex: false },
      { nome: "id_famiglia_articolo_temp", default_val: null, complex: false },
      { nome: "id_tabella", default_val: null, complex: false },
      { nome: "immagine", default_val: "", complex: false },
      { nome: "immagine_estensione", default_val: "", complex: false },
      { nome: "immagine_full", default_val: "", complex: false },
      { nome: "immagine_nome", default_val: "", complex: false },
      { nome: "marchio", default_val: "", complex: false },
      { nome: "modelli", default_val: new Array(), complex: true },
      { nome: "validita", default_val: 1, complex: false },
    ];

    return campi;
  }
}

export default {
  name: "FamiglieArticolo",
  components: {
    MiniaturaComprimibile,
    Modules: () => import("@/components/TOOLS/Modules"),
    // Modules,
    SnackbarQV,
  },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      indice_sel: null,
      modello_sel: "",
      riga_sel: new Riga(),
      search_famiglia: null,
      search_marchio: null,
      search_modello: null,

      // Modal
      conferma_elimina_modello: false,
      conferma_elimina_riga: false,
      dialog_aggiungi_famiglia: false,
      dialog_conferma_salvataggio: false,
      dialog_modifica: false,
      dialog_modifica_modello: false,
      dialog_gestisci_montaggio_famiglia: false,
      overlay: false,

      // Array
      headers_diario: new Array(),
      headers_famiglie: [
        { text: "Modifica", value: "modifica", sortable: false },
        { text: "Articoli", value: "articoli", sortable: false },
        { text: "Famiglia", value: "des", sortable: false },
        { text: "Marchio", value: "marchio", sortable: false },
        { text: "Modello", value: "modelli", sortable: false },
        { text: "Immagine", value: "immagine", sortable: false },
        { text: "Elimina", value: "elimina", sortable: false },
      ],
      items_colonne_diario: new Array(),
      items_famiglie: [],
      items_famiglie_diario: [],
      items_famiglie_tabella: new Array(),
      items_famiglie_visualizzate: new Array(),
    };
  },
  computed: {
    items_modelli() {
      if (this.items_famiglie == null) {
        return [];
      } else if (this.items_famiglie.length == 0) {
        return [];
      } else {
        const res = new Array();
        this.items_famiglie.forEach((f) => {
          f.modelli.forEach((m) => {
            if (!res.includes(m) && f.validita === 1) {
              res.push(m);
            }
          });
        });

        return res;
      }
    },
  },
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    aggiungiFamigliaArticolo() {
      this.dialog_aggiungi_famiglia = true;
      this.riga_sel = new Riga();
    },
    aggiornaFamiglia() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "Famiglia",
          filter: "validita = 1",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_famiglie_tabella = res.data;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    aggiungiModello() {
      /* Per sicurezza resetto le variabili di supporto
       * e poi apro il dialog di modifica. */
      this.indice_sel = null;
      this.modello_sel = "";
      this.dialog_modifica_modello = true;
    },
    annullaEliminaModello() {
      this.conferma_elimina_modello = false;
      this.indice_sel = null;
    },
    annullaEliminaRiga() {
      this.conferma_elimina_riga = false;
      this.riga_sel = new Riga();
    },
    chiudiDialogAggiungiFamiglia() {
      this.riga_sel = new Riga();
      this.dialog_aggiungi_famiglia = false;
    },
    chiudiDialogModificaModello() {
      this.dialog_modifica_modello = false;
      this.indice_sel = null;
      this.modello_sel = "";
    },
    chiudiDialogModifica() {
      this.dialog_modifica = false;
      this.riga_sel = new Riga();
    },
    clickArticoli(arg) {
      this.$store.state.id_famiglia_articolo = arg.id_tabella;
      this.$router.push("/home/electrical/EMArticolo");
    },
    clickEliminaModello(i) {
      this.indice_sel = i;
      this.conferma_elimina_modello = true;
    },
    clickEliminaRiga(arg) {
      this.riga_sel = new Riga(arg);
      this.conferma_elimina_riga = true;
    },
    clickGestioneMontaggioFamiglia() {
      this.items_famiglie_diario = new Array();
      this.headers_diario = new Array();
      this.headers_diario.push({
        text: "Famiglia",
        value: "des_famiglia",
        sortable: false,
      });

      /* Aggiorno gli headers delle colonne del diario,
       * perché nel frattempo potrei averle modificate
       * o aggiunte o eliminate.*/
      this.items_colonne_diario.forEach((c) => {
        this.headers_diario.push(Object.assign({}, c));
      });

      // Mi prendo le autorizzazioni di ogni famiglia
      this.getAbilitazioniFamiglia();

      this.dialog_gestisci_montaggio_famiglia = true;
    },
    clickIndietro() {
      this.$router.push("/home/electrical");
    },
    clickModifica(arg) {
      this.riga_sel = new Riga(arg);
      this.dialog_modifica = true;
    },
    clickSalvataggioGenerale() {
      if (this.items_famiglie_visualizzate.length === 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non è attualmente selezionato alcun elemento da modificare."
        );
        return;
      }

      this.dialog_conferma_salvataggio = true;
    },
    eliminaModello() {
      /* Se invece l'indice selezionato non è
       * null e sto modificando un elemento aggiorno
       * l'indice giusto della riga selezionata. */
      this.riga_sel.modelli.splice(this.indice_sel, 1);

      // Resetto le variabili di supporto e chiudo il dialog.
      this.conferma_elimina_modello = false;
      this.indice_sel = null;
      this.modello_sel = "";
    },
    eliminaRiga() {
      this.riga_sel.validita = 0;

      // Aggiorno le famiglie gli elementi totali
      for (let i = 0; i < this.items_famiglie.length; i++) {
        if (
          this.items_famiglie[i].id_famiglia_articolo ===
          this.riga_sel.id_famiglia_articolo
        ) {
          this.$set(this.items_famiglie, i, new Riga(this.riga_sel));
        }
      }

      // Aggiorno gli elementi visualizzati
      for (let i = 0; i < this.items_famiglie_visualizzate.length; i++) {
        if (
          this.items_famiglie_visualizzate[i].id_famiglia_articolo ===
          this.riga_sel.id_famiglia_articolo
        ) {
          this.$set(
            this.items_famiglie_visualizzate,
            i,
            new Riga(this.riga_sel)
          );
        }
      }

      // Resetto le variabili di supporto e chiudo il dialog.
      this.conferma_elimina_riga = false;
      this.riga_sel = new Riga();
    },
    formattaModelli(arg) {
      if (arg.modelli.length === 0) {
        return "";
      } else if (arg.modelli.length === 1) {
        return arg.modelli[0];
      } else {
        let res = "";
        arg.modelli.forEach((m) => {
          res += m + ", ";
        });

        return res.substr(0, res.length - 2);
      }
    },
    getAbilitazioniFamiglia() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getabilitazionifamiglia",
          token: localStorage.user_token,
        },
      };
      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            // Resetto l'array delle mie abilitazioni di caratteristica.
            this.items_famiglie_diario = new Array();

            if (res.data.result.abilitazioni) {
              // Considero tutte le caratteristiche
              res.data.result.abilitazioni.forEach((a) => {
                /* Se non trovo un oggetto relativo alla famiglia della
                 * caratteristica che sto guardando, lo genero e gli
                 * metto dentro la caratteristica. */
                if (
                  this.items_famiglie_diario.filter(
                    (e) => e.des_famiglia === a.des_famiglia
                  ).length == 0
                ) {
                  this.items_famiglie_diario.push({
                    des_famiglia: a.des_famiglia,
                    abilitazioni: [a],
                  });
                } else {
                  /* Se invece c'era già un oggetto corrispondente alla
                   * famiglia della mia caratteristica, gli metto dentro
                   * la caratteristica che sto guardando. */
                  this.items_famiglie_diario
                    .filter((f) => f.des_famiglia === a.des_famiglia)[0]
                    .abilitazioni.push(a);
                }
              });
            } else {
              this.items_famiglie_diario = new Array();
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },
    getFamigliaArticolo() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getfamigliaarticolo",
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_famiglie_visualizzate = new Array();
            const arr_tmp = new Array();

            res.data.result.forEach((e) => {
              /* Genero un array dallo splitting della
               * stringa dei modelli che il BE mi ritorna. */
              const modelli_tmp =
                e.modelli != null && e.modelli != ""
                  ? e.modelli.split(";")
                  : [];

              /* Il BE mi da sempre un ';' finale che splittato
               * mi crea un indice vuoto alla fine dell'array:
               * elimino questa ultima posizione inutile. */
              if (modelli_tmp.length > 0) {
                modelli_tmp.pop();
              }

              /* Valorizzo i modelli del mio oggetto con
               * l'array temporaneo che mi sono costruito. */
              e.modelli = modelli_tmp;
              arr_tmp.push(new Riga(e));
            });

            this.items_famiglie = arr_tmp;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    getTabelle() {
      /* Chiamata per prendere le varie famiglie che
       * servono al componente nelle varie select. */
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "'Famiglia','PARTE_BARCA'",
          filter: "validita = 1",
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.items_famiglie_tabella = new Array();
            this.items_colonne_diario = new Array();

            this.items_famiglie_tabella = res.data.Famiglia
              ? res.data.Famiglia
              : new Array();
            if (res.data.PARTE_BARCA) {
              // Ordino gli elementi in base al parametro "ordine".
              res.data.PARTE_BARCA.sort((a, b) =>
                a.ordine < b.ordine ? -1 : a.ordine > b.ordine ? 1 : 0
              );

              // Uso gli elementi per popolare l'array di supporto.
              res.data.PARTE_BARCA.forEach((e) => {
                this.items_colonne_diario.push({
                  text: e.des,
                  value: e.des,
                  sortable: false,
                });
              });
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          this.overlay = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    handleImmagineFull(arg_riferimento, immagine_full) {
      this.riga_sel = new Riga(arg_riferimento);
      this.riga_sel.immagine_full = immagine_full;

      // Aggiorno le famiglie
      for (let i = 0; i < this.items_famiglie.length; i++) {
        if (
          this.items_famiglie[i].id_famiglia_articolo ===
          this.riga_sel.id_famiglia_articolo
        ) {
          this.$set(this.items_famiglie, i, new Riga(this.riga_sel));
        }
      }

      // Aggiorno le famiglie visualizzate
      for (let i = 0; i < this.items_famiglie_visualizzate.length; i++) {
        if (
          this.items_famiglie_visualizzate[i].id_famiglia_articolo ===
          this.riga_sel.id_famiglia_articolo
        ) {
          this.$set(
            this.items_famiglie_visualizzate,
            i,
            new Riga(this.riga_sel)
          );
        }
      }

      this.riga_sel = new Riga();
    },
    handleSceltaImmagine(arg_riferimento, arg_dati_aggiornati) {
      this.riga_sel = new Riga(arg_riferimento);

      this.riga_sel.immagine = arg_dati_aggiornati.img_miniatura;
      this.riga_sel.immagine_full = arg_dati_aggiornati.img_full;
      this.riga_sel.immagine_nome = arg_dati_aggiornati.img_nome;
      this.riga_sel.immagine_estensione = arg_dati_aggiornati.img_estensione;
      this.riga_sel.be_call_needed = arg_dati_aggiornati.be_call_needed;

      // Aggiorno le famiglie
      for (let i = 0; i < this.items_famiglie.length; i++) {
        if (
          this.items_famiglie[i].id_famiglia_articolo ===
          this.riga_sel.id_famiglia_articolo
        ) {
          this.$set(this.items_famiglie, i, new Riga(this.riga_sel));
        }
      }

      // Aggiorno le famiglie visualizzate
      for (let i = 0; i < this.items_famiglie_visualizzate.length; i++) {
        if (
          this.items_famiglie_visualizzate[i].id_famiglia_articolo ===
          this.riga_sel.id_famiglia_articolo
        ) {
          this.$set(
            this.items_famiglie_visualizzate,
            i,
            new Riga(this.riga_sel)
          );
        }
      }

      this.riga_sel = new Riga();
    },
    modificaModello(i) {
      /* Valorizzo il modello selezionato con il valore
       * dell'indice dell'elemento cliccato dall'utente. */
      this.indice_sel = i;
      this.modello_sel = this.riga_sel.modelli[i];

      // Apro il dialog di modifica
      this.dialog_modifica_modello = true;
    },
    ricerca() {
      console.log("entrato");

      /* Se non ho valorizzato nessun filtro
       * ritorno direttamente array vuoto. */
      if (
        this.search_famiglia == null &&
        this.search_marchio == null &&
        this.search_modello == null
      ) {
        console.log("piantato");
        this.items_famiglie_visualizzate = new Array();
        return;
      }

      let items_famiglie_tmp = [];
      this.items_famiglie.forEach((elem) => {
        items_famiglie_tmp.push(elem);
      });

      //Filtro la famiglia
      if (this.search_famiglia != null) {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_famiglie_tmp.forEach((elem) => {
          if (elem.id_tabella == this.search_famiglia) {
            res.push(elem);
          }
        });
        items_famiglie_tmp = res;
      }

      //Filtro il marchio
      if (this.search_marchio != null) {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_famiglie_tmp.forEach((elem) => {
          if (elem.marchio == this.search_marchio) {
            res.push(elem);
          }
        });
        items_famiglie_tmp = res;
      }

      //Filtro il modello
      if (this.search_modello != null) {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_famiglie_tmp.forEach((elem) => {
          if (elem.modelli.includes(this.search_modello)) {
            res.push(elem);
          }
        });
        items_famiglie_tmp = res;
      }

      this.items_famiglie_visualizzate = [];
      this.items_famiglie_visualizzate = items_famiglie_tmp;
    },
    salvaAggiungiFamiglia() {
      // Contorllo che l'utente abbia scelto una famiglia
      if (this.riga_sel.id_tabella == null) {
        this.$refs.SnackbarQV(
          "orange",
          "È necessario indicare una famiglia per salvare un nuovo record in tabella."
        );
        return;
      }

      this.items_famiglie_tabella.forEach((f) => {
        if (f.id_tabella === this.riga_sel.id_tabella) {
          this.riga_sel.des = f.des;
        }
      });

      const id_tmp = moment().valueOf();
      this.riga_sel.id_famiglia_articolo = -id_tmp;
      this.riga_sel.id_famiglia_articolo_temp = id_tmp;

      this.$set(
        this.items_famiglie,
        this.items_famiglie.length,
        new Riga(this.riga_sel)
      );
      this.$set(
        this.items_famiglie_visualizzate,
        this.items_famiglie_visualizzate.length,
        new Riga(this.riga_sel)
      );
      this.dialog_aggiungi_famiglia = false;
      this.dialog_modifica = true;
    },
    salvaModello() {
      if (this.indice_sel === null) {
        /* Se non ho un indice selezionato e quindi sto
         * aggiungendo un elemento, aggiungo il modello
         * selezionato come ultimo elemento dell'array
         * dei modelli della riga selezionata. */
        this.riga_sel.modelli.push(this.modello_sel);
      } else {
        /* Se invece l'indice selezionato non è
         * null e sto modificando un elemento aggiorno
         * l'indice giusto della riga selezionata. */
        this.riga_sel.modelli[this.indice_sel] = this.modello_sel;
      }

      // Resetto le variabili di supporto e chiudo il dialog.
      this.dialog_modifica_modello = false;
      this.indice_sel = null;
      this.modello_sel = "";
    },
    salvaModifiche() {
      // Aggiorno le famiglie gli elementi totali
      for (let i = 0; i < this.items_famiglie.length; i++) {
        if (
          this.items_famiglie[i].id_famiglia_articolo ===
          this.riga_sel.id_famiglia_articolo
        ) {
          this.$set(this.items_famiglie, i, new Riga(this.riga_sel));
        }
      }

      // Aggiorno gli elementi visualizzati
      for (let i = 0; i < this.items_famiglie_visualizzate.length; i++) {
        if (
          this.items_famiglie_visualizzate[i].id_famiglia_articolo ===
          this.riga_sel.id_famiglia_articolo
        ) {
          this.$set(
            this.items_famiglie_visualizzate,
            i,
            new Riga(this.riga_sel)
          );
        }
      }

      // Chiudo il dialog di modifica
      this.dialog_modifica = false;
    },
    salvataggioGenerale() {
      this.dialog_conferma_salvataggio = false;

      const arr_tmp = new Array();
      const arr_img_full = new Array();

      this.items_famiglie_visualizzate.forEach((f) => {
        const f_tmp = new Riga(f);

        if (f_tmp.be_call_needed === true) {
          arr_img_full.push({
            id_famiglia_articolo_temp: f.id_famiglia_articolo_temp,
            immagine_full: f_tmp.immagine_full,
            immagine_nome: f_tmp.immagine_nome,
            immagine_estensione: f_tmp.immagine_estensione,
          });
        }

        delete f_tmp.immagine_full;

        f_tmp.id_famiglia_articolo =
          f_tmp.id_famiglia_articolo < 0 ? -1 : f_tmp.id_famiglia_articolo;

        let modelli_tmp = "";
        f_tmp.modelli.forEach((m) => {
          modelli_tmp += m + ";";
        });

        f_tmp.modelli = modelli_tmp;
        arr_tmp.push(_.cloneDeep(f_tmp));
      });

      const setfamigliaarticolo = {
        controller: "MAGAZZINO",
        method: "PUT",
        richiesta: {
          action: "setfamigliaarticolo",
          token: localStorage.user_token,
          tabella: arr_tmp,
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", setfamigliaarticolo)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            if (arr_img_full.length > 0) {
              /* Mi faccio un array per gli identificativi di
               * riferimento degli allegati da chiedere al BE. */
              const arr_id_req_tmp = new Array();

              // Cerco gli identificativi di riferimento per la request.
              arr_img_full.forEach((i) => {
                res.data.result.forEach((r) => {
                  if (
                    i.id_famiglia_articolo_temp === r.id_famiglia_articolo_temp
                  ) {
                    /* Registro l'id di riferimento definitivo
                     * che il BE ha assegnato a ciascun oggetto. */
                    i.id_famiglia_articolo = r.id_famiglia_articolo;

                    // Popolo l'array degli identificativi di riferimento per la request.
                    arr_id_req_tmp.push(r.id_famiglia_articolo);
                  }
                });
              });

              /* Chiedo al BE gli allegati attuali per
               * gli id di riferimento che ho in tasca. */
              const getallegatiall = {
                controller: "MAGAZZINO",
                method: "POST",
                richiesta: {
                  action: "getallegatiall",
                  tipo: "FAMIGLIA_ARTICOLO",
                  token: localStorage.user_token,
                  array_id: arr_id_req_tmp,
                },
              };

              this.overlay = true;
              this.$store
                .dispatch("api", getallegatiall)
                .then((res2) => {
                  this.overlay = false;
                  if (res2.status === 200) {
                    /* Mi faccio un nuovo array che conterrà
                     * gli oggetti effettivi da salvare. */
                    const arr_img_salvataggio = new Array();

                    /* Metto a 0 la validita degli eventuali allegati già presenti
                     * e li aggiungo all'array di salvataggio definitivo. */
                    res2.data.result.forEach((a) => {
                      a.validita = 0;
                      arr_img_salvataggio.push(a);
                    });

                    // Aggiungo all'array di salvataggio definitivo i nuovi allegati.
                    arr_img_full.forEach((i) => {
                      arr_img_salvataggio.push({
                        id_allegato: -1,
                        id_riferimento: i.id_famiglia_articolo,
                        tipo: "FAMIGLIA_ARTICOLO",
                        path: i.image_for_viewer_name,
                        des_allegato: "Allegato",
                        estensione: i.immagine_estensione,
                        validita: 1,
                      });
                    });

                    // Eseguo il salvataggio dei vari allegati sul DB.
                    const setallegati = {
                      controller: "MAGAZZINO",
                      method: "PUT",
                      richiesta: {
                        action: "setallegati",
                        token: localStorage.user_token,
                        allegati: arr_img_salvataggio,
                      },
                    };

                    this.overlay = true;
                    this.$store
                      .dispatch("api", setallegati)
                      .then((res3) => {
                        this.overlay = false;
                        if (res3.status === 200) {
                          // Mi faccio un form data per il salvataggio finale
                          let form_data = new FormData();

                          arr_img_full.forEach((i) => {
                            const byteString = atob(
                              i.immagine_full.split(",")[1]
                            );
                            const mimeString = i.immagine_full
                              .split(",")[0]
                              .split(":")[1]
                              .split(";")[0];

                            const ab = new ArrayBuffer(byteString.length);
                            const ia = new Uint8Array(ab);
                            for (let i = 0; i < byteString.length; i += 1) {
                              ia[i] = byteString.charCodeAt(i);
                            }
                            let blob = new Blob([ab], { type: mimeString });
                            blob.name = i.immagine_nome;
                            blob.lastModified = moment().valueOf();

                            form_data.append(
                              localStorage.dbname +
                                "_" +
                                "FAMIGLIA_ARTICOLO_" +
                                i.id_famiglia_articolo +
                                ".png",
                              blob
                            );
                          });

                          /* Salvo i dati dell'allegato collegandoli al
                           * riferimento che il BE mi ha resittuito. */
                          new Promise((resolve, reject) => {
                            axios
                              .post(
                                this.$store.state.config.ip +
                                  "api/Allegato/inserisci",
                                form_data,
                                {
                                  headers: {
                                    Token: localStorage.user_token,
                                  },
                                }
                              )
                              .then((result) => {
                                this.overlay = false;
                                if (result.data) {
                                  this.$refs.SnackbarQV.print(
                                    "success",
                                    "Modifica effettuata con successo!"
                                  );
                                }

                                resolve(result);
                              })
                              .catch((err) => {
                                this.overlay = false;
                                reject(err);
                              });
                          });
                        } else {
                          this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                          );
                        }
                      })
                      .catch((e) => {
                        this.overlay = false;
                        console.error(e);
                        this.$refs.SnackbarQV.print(
                          "error",
                          "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );
                      });
                  } else {
                    this.$refs.SnackbarQV.print(
                      "orange",
                      "Errore di comunicazione col server, non è stato possibile caricare i dati."
                    );
                  }
                })
                .catch((e) => {
                  this.overlay = false;
                  console.error(e);
                  this.$refs.SnackbarQV.print(
                    "error",
                    "Errore di comunicazione col server, non è stato possibile caricare i dati."
                  );
                });
            } else {
              /* Se non c'erano allegati da salvare, la procedura di
               * salvataggio è conclusa e stampo una snackbar di conferma. */
              this.$refs.SnackbarQV.print(
                "success",
                "Salvataggio avvenuto con successo!"
              );
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          this.overlay = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    salvaGestisciMontaggioFamiglia() {
      /* Costruisco l'array di oggetti da salvare prendendoli
       * dalle abilitazioni di ogni singola famiglia. */
      const arr_tmp = new Array();
      this.items_famiglie_diario.forEach((f) => {
        f.abilitazioni.forEach((a) => {
          arr_tmp.push(a);
        });
      });

      // Genero la request.
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setabilitazionifamiglia",
          token: localStorage.user_token,
          tabella: arr_tmp,
        },
      };

      // Spedisco la request e gestisco la response.
      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.dialog_gestisci_montaggio_famiglia = false;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },
    switchOnOff(arg) {
      const value = arg.abilitato == 1 ? 0 : 1;
      this.$set(arg, "abilitato", value);
    },
  },
  created() {},
  mounted() {
    this.getTabelle();
    this.getFamigliaArticolo();
  },
};
</script>
<style scoped>
</style>